const m = require('minthril');
const { component } = require('../../component');

function bytes(value) {
  if (value < 1024) return `${value} B`;
  if (value < 1024 * 1024) return `${(value / 1024).toFixed(1)} KB`;
  return `${(value / (1024 * 1024)).toFixed(1)} MB`;
}

function duration(milliseconds) {
  const value = Number(milliseconds || 0);
  if (value < 1000) return `${Math.round(value)} ms`;

  const seconds = value / 1000;
  if (seconds < 60) return `${seconds.toFixed(1)} s`;

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.round(seconds % 60);
  if (minutes < 60) {
    return remainingSeconds ? `${minutes} min ${remainingSeconds} s` : `${minutes} min`;
  }

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return remainingMinutes ? `${hours} hr ${remainingMinutes} min` : `${hours} hr`;
}

function averageDuration(totalDuration, count) {
  return count ? duration(totalDuration / count) : '-';
}

function cacheHitRate(usage) {
  return usage.pageHits ? `${Math.round((usage.cacheHits / usage.pageHits) * 100)}%` : '-';
}

const UsageTotals = component(() => ({
  view: ({ attrs: { usage, heading = 'Usage totals · last 7 days' } }) => m('section.usage-totals', [
    m('h3', heading),
    m('dl.usage-metrics', [
      m('div', m('dt', 'Page hits'), m('dd', Number(usage.pageHits || 0).toLocaleString())),
      m('div', m('dt', 'Proxied requests'), m('dd', Number(usage.proxiedRequests || 0).toLocaleString())),
      m('div', m('dt', 'Response data served'), m('dd', bytes(usage.responseBodyBytes))),
      m('div', m('dt', 'Request data received'), m('dd', bytes(usage.requestBodyBytes))),
      m('div', m('dt', 'Cache hits'), m('dd', Number(usage.cacheHits || 0).toLocaleString())),
      m('div', m('dt', 'Cache misses'), m('dd', Number(usage.cacheMisses || 0).toLocaleString())),
      m('div', m('dt', 'Cache hit rate'), m('dd', cacheHitRate(usage))),
      m('div', m('dt', 'Stale cache served'), m('dd', Number(usage.staleCacheHits || 0).toLocaleString())),
      m('div', m('dt', 'Full renders'), m('dd', Number(usage.renders || 0).toLocaleString())),
      m('div', m('dt', 'Average render time'), m('dd', averageDuration(
        usage.renderDurationMs,
        usage.renders
      ))),
      m('div', m('dt', 'Normalized worker compute time'), m('dd', duration(usage.workerComputeMs))),
      m('div', m('dt', 'Average normalized worker compute time'), m('dd', averageDuration(
        usage.workerComputeMs,
        usage.renders + usage.validations
      ))),
      m('div', m('dt', 'Validation refreshes'), m('dd', Number(usage.validations || 0).toLocaleString())),
      m('div', m('dt', 'Average validation time'), m('dd', averageDuration(
        usage.validationDurationMs,
        usage.validations
      )))
    ])
  ])
}));

module.exports = { UsageTotals, averageDuration, bytes, duration };
